(async function () {
  "use strict";

  var CLOUDFRONT_URL = "https://d3mn72jo1j5k08.cloudfront.net/ktb9zp-vy/";
  

  var state = {
    config: null,
    product: null,
    productId: "",
    variantId: "",
    isAdding: false
  };

  function money(amount) {
    var value = Number(amount);
    if (!Number.isFinite(value)) value = 0;
     
    return "$" + value.toFixed(2);

    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : "AUD";

    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency
      }).format(value);
    } catch (error) {
      return "$" + value.toFixed(2);
    }
  }

  function shopifyRoute(path) {
    var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";

    return routeRoot.replace(/\/?$/, "/") + path.replace(/^\//, "");
  }

  function getProductForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function getVariantId(form) {
    var scope = form || document;
    var input = scope.querySelector(
      'input[name="id"]:checked, select[name="id"], input[type="hidden"][name="id"], input[name="id"]'
    );

    if (typeof window.currentVariantId !== "undefined" && window.currentVariantId) {
      return String(window.currentVariantId);
    }

    return input && input.value ? String(input.value) : "";
  }

  function getProductHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  async function getProductFromShopify() {
    return currentProductId;
    if (window.currentProduct && window.currentProduct.id) {
      return window.currentProduct;
    }

    if (window.meta && window.meta.product && window.meta.product.id) {
      return window.meta.product;
    }

    var handle = getProductHandle();
    if (!handle) return null;

    try {
      var response = await fetch(shopifyRoute("products/" + handle + ".js"), {
        cache: "no-store"
      });
      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      return null;
    }
  }

  function getProductId(product) {
    if (typeof window.currentProductId !== "undefined" && window.currentProductId) {
      return String(window.currentProductId);
    }

    if (product && product.id) {
      return String(product.id);
    }

    return "";
  }

  function labelFromKey(key) {
    return String(key || "")
      .replace(/_/g, " ")
      .replace(/\b\w/g, function (letter) {
        return letter.toUpperCase();
      });
  }

  function normalizeRows(source, fallback) {
    var rows = source;

    if (rows && !Array.isArray(rows) && typeof rows === "object") {
      rows = Object.keys(rows).map(function (key) {
        return {
          label: labelFromKey(key),
          price: rows[key]
        };
      });
    }

    rows = Array.isArray(rows) ? rows : [];
    rows = rows.map(function (row) {
      var label = String(row && row.label ? row.label : "").trim();
      var price = Number(row && row.price !== undefined ? row.price : 0);
      return {
        label: label,
        price: Number.isFinite(price) && price >= 0 ? price : 0
      };
    }).filter(function (row) {
      return row.label !== "";
    });

    return rows.length ? rows : fallback.slice();
  }

  function normalizeConfig(productSettings) {
    return {
      materials: normalizeRows(
        productSettings && productSettings.materials,
        null
      ),
      holes: normalizeRows(
        productSettings && productSettings.holes,
        null
      )
    };
  }

  async function loadConfig(productId) {
    if (!productId) return null;
    //productId =9291890819298
    var url = CLOUDFRONT_URL + encodeURIComponent(productId) + ".json";

    try {
      var response = await fetch(url, { cache: "no-store" });
      if (!response.ok) return null ;
      var payload = await response.json();
      return normalizeConfig(payload && payload.ProductSettings);
    } catch (error) {
      return null;
    }
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function optionHtml(items) {
    return items.map(function (item, index) {
      return '<option value="' + index + '">' + escapeHtml(item.label) + "</option>";
    }).join("");
  }

  function installStyles() {
  if (document.getElementById("ngs-size-calculator-style")) return;

  var style = document.createElement("style");
  style.id = "ngs-size-calculator-style";

  style.textContent = `
    .ngs-size-calculator {
      margin: 20px 0;
      padding: 5px;
     /* border: 1px solid #d7d7d7;*/
         background: transparent;
    color: var(--color);
      font-family: inherit;
      max-width: 560px;
    }

    .ngs-size-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 14px;
    }

    .ngs-size-field-full {
      grid-column: 1 / -1;
    }

    .ngs-size-field {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    .ngs-size-field label {
      font-size: 14px;
      font-weight: 600;
    }

    .ngs-size-field select,
    .ngs-size-field input {
      width: 100%;
      box-sizing: border-box;
      border: 1px solid #b8b8b8;
      border-radius: 4px;
      padding: 10px;
      font: inherit;
     color: white;
  background-color: transparent;
    }

.ngs-size-field select {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #b8b8b8;
  border-radius: 4px;
  padding: 10px 50px 10px 10px;
  font: inherit;
  background: #171717;
  color: #fff;

  appearance: none;
  -webkit-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='2'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 24px 24px;
}
.ngs-size-field select option {
  background:#202226;
  color:  #fff;
}

  
.ngs-size-field select:focus,
.ngs-size-field input:focus {
  outline: none;
  border-color: #fff;
  box-shadow: none;
}
  
    .ngs-size-total {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      margin-top: 16px;
      padding-top: 14px;
      border-top: 1px solid #e4e4e4;
      font-size: 18px;
      font-weight: 700;
    }

    .ngs-size-breakdown {
      margin-top: 6px;
      color: #666;
      font-size: 13px;
      display: none;
    }

    .ngs-size-button {
      width: 100%;
      border: 0;
      border-radius: 14px;
      font-family: Inter, sans-serif;
      font-size: 14px;
      padding: 13px 16px;
      background: rgb(245, 160, 0);
      color: black;
      font-weight: 400;
      cursor: pointer;
        transition: filter 0.2s ease;
    }

.ngs-size-button:hover {
   filter: brightness(0.9);
}

    .ngs-size-button[disabled] {
      opacity: 0.55;
      cursor: not-allowed;
    }

    .ngs-size-error {
      margin-top: 10px;
      color: #b00020;
      font-size: 14px;
    }

    @media (max-width: 640px) {
      .ngs-size-grid {
        grid-template-columns: 1fr;
      }

      .ngs-size-field-full {
        grid-column: auto;
      }

      .ngs-size-calculator {
        padding: 5px;
      }
    }
  `;

  document.head.appendChild(style);
}

  function calculate() {
    var materialIndex = Number(document.getElementById("ngs-material").value);
    var holesIndex = Number(document.getElementById("ngs-holes").value);
    var material = state.config.materials[materialIndex] || state.config.materials[0] || { label: "", price: 0 };
    var holes = state.config.holes[holesIndex] || state.config.holes[0] || { label: "", price: 0 };
    var widthMm = Number(document.getElementById("ngs-width").value);
    var heightMm = Number(document.getElementById("ngs-height").value);
    var areaSqm = widthMm > 0 && heightMm > 0 ? (widthMm / 1000) * (heightMm / 1000) : 0;
    var materialRate = Number(material.price) || 0;
    var holesPrice = Number(holes.price) || 0;
    var total = areaSqm > 0 ? (areaSqm * materialRate) + holesPrice : 0;

    return {
      material: material,
      holes: holes,
      widthMm: widthMm,
      heightMm: heightMm,
      areaSqm: areaSqm,
      materialRate: materialRate,
      holesPrice: holesPrice,
      total: total
    };
  }

  function updateTotal() {
    var result = calculate();
    var totalElement = document.getElementById("ngs-total-price");
    var breakdownElement = document.getElementById("ngs-price-breakdown");
    var addButton = document.getElementById("ngs-add-to-cart");

    totalElement.textContent = money(result.total);
    breakdownElement.textContent = result.areaSqm > 0
      ? result.areaSqm.toFixed(4) + " sqm x " + money(result.materialRate) +
        " + holes " + money(result.holesPrice)
      : "Enter width and height in mm";
    addButton.disabled = state.isAdding;
  }

  function renderCalculator(form) {
    installStyles();

    var existing = document.getElementById("ngs-size-calculator");
    if (existing) existing.remove();

    var wrapper = document.createElement("div");
    wrapper.id = "ngs-size-calculator";
    wrapper.className = "ngs-size-calculator";
    wrapper.innerHTML = `
  <div class="ngs-size-grid">
    <div class="ngs-size-field ngs-size-field-full">
      <label for="ngs-material">Material</label>
      <select id="ngs-material">${optionHtml(state.config.materials)}</select>
    </div>

    <div class="ngs-size-field ngs-size-field-full">
      <label for="ngs-holes">Holes</label>
      <select id="ngs-holes">${optionHtml(state.config.holes)}</select>
    </div>

    <div class="ngs-size-field">
      <label for="ngs-width">Width (mm)</label>
      <input id="ngs-width" type="number" inputmode="decimal" min="1" step="1">
    </div>

    <div class="ngs-size-field">
      <label for="ngs-height">Height (mm)</label>
      <input id="ngs-height" type="number" inputmode="decimal" min="1" step="1">
    </div>
  </div>

  <div class="ngs-size-total">
    <span>Total</span>
    <span id="ngs-total-price">${money(0)}</span>
  </div>

  <div id="ngs-price-breakdown" class="ngs-size-breakdown">
    Enter width and height in mm
  </div>

 

  <div id="ngs-size-error" class="ngs-size-error" aria-live="polite"></div>
`;

var quantityWrapper = form.querySelector(".quantity-selector-wrapper");

if (quantityWrapper) {
    quantityWrapper.parentNode.insertBefore(wrapper, quantityWrapper);
} else {
    form.appendChild(wrapper);
}
const addToCartButtoHtml =` <button id="ngs-add-to-cart" class="ngs-size-button button add-to-cart-button button button--AeEFWWVhNYjRLM1QzM__add-to-cart" type="button">
    <span aria-hidden="true" class="svg-wrapper add-to-cart-icon">
      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="var(--icon-stroke-width)"
          d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"
        ></path>
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-width="var(--icon-stroke-width)"
          d="M14.608 12.563v5m2.5-2.5h-5"
        ></path>
      </svg>
    </span>
    Add to cart
  </button>`
   // form.parentNode.insertBefore(wrapper, form);

 

var buttonsWrapper = form.querySelector("add-to-cart-component");

if (buttonsWrapper) {
    buttonsWrapper.insertAdjacentHTML("afterbegin", addToCartButtoHtml);
} else {
    form.insertAdjacentHTML("afterbegin", addToCartButtoHtml);
}

    ["ngs-material", "ngs-holes", "ngs-width", "ngs-height"].forEach(function (id) {
      document.getElementById(id).addEventListener("input", updateTotal);
      document.getElementById(id).addEventListener("change", updateTotal);
    });
    document.getElementById("ngs-add-to-cart").addEventListener("click", addToCart);

    hideNativeButtons(form);
    updateTotal();
  }

function hideNativeButtons(form) {
  var selectors = [
    'button[name="add"]',
    'input[name="add"]',
    'button[type="submit"]',
    'input[type="submit"]',
    ".shopify-payment-button"
  ];

  selectors.forEach(function (selector) {
    form.querySelectorAll(selector).forEach(function (element) {
      element.style.visibility = "hidden";
      element.style.pointerEvents = "none";
    });
  });
}
  function setError(message) {
    var element = document.getElementById("ngs-size-error");
    if (element) element.textContent = message || "";
  }

  function getQuantity(form) {
    var input = form.querySelector('input[name="quantity"], select[name="quantity"]');
    var value = input && input.value ? parseInt(input.value, 10) : 1;
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  function setHiddenInput(form, name, value) {
    var selector = 'input[type="hidden"][name="' + name.replace(/"/g, '\\"') + '"]';
    var input = form.querySelector(selector);

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      form.appendChild(input);
    }

    input.value = value;
  }

  function setFormProperties(form, properties) {
    Object.keys(properties).forEach(function (key) {
      setHiddenInput(form, "properties[" + key + "]", properties[key]);
    });
  }

  function findNativeAddButton(form) {
const productForm = document.querySelector('product-form-component');

if (productForm) {
    const form = productForm.querySelector('form');

    if (form) {
        const addButton = form.querySelector('button[name="add"]');

       return addButton;
    }
}

    return null;
  }

  function clickNativeAddToCart(form,button) {
    var nativeButton = findNativeAddButton(form);
    if (!nativeButton) return false;

    nativeButton.click();
    setTimeout(() => {
       state.isAdding = false;
    button.disabled = false;
    button.innerHTML = `
  <span aria-hidden="true" class="svg-wrapper add-to-cart-icon">
    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="var(--icon-stroke-width)"
        d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"
      ></path>
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-width="var(--icon-stroke-width)"
        d="M14.608 12.563v5m2.5-2.5h-5"
      ></path>
    </svg>
  </span>
  Add to cart
`;
    }, 2500);
    return true;
  }

  async function addToCart() {
    var form = getProductForm();
    var result = calculate();
    var button = document.getElementById("ngs-add-to-cart");

    if (!form) {
      setError("Unable to find the product form.");
      return;
    }

    state.variantId = getVariantId(form);
    if (!state.variantId) {
      setError("Please select a product option first.");
      return;
    }

    if (!(result.widthMm > 0 && result.heightMm > 0)) {
      setError("Please enter width and height in mm.");
      return;
    }

    var activeCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : "AUD";
    var price = result.total.toFixed(2);
    var readableProperties = {
      Material: result.material.label,
      Holes: result.holes.label,
      "Width (mm)": String(result.widthMm),
      "Height (mm)": String(result.heightMm),
      "Area (sqm)": result.areaSqm.toFixed(4),
      "Total price": money(result.total)
    };
    var properties = Object.assign({}, readableProperties, {
      __ngs_customPrice: price,
      __ngs_productBaseCurrencyPrice: price,
      __ngs_originalCurrency: activeCurrency,
      __ngs_all_properties_data: JSON.stringify(readableProperties)
    });

    setFormProperties(form, properties);

    state.isAdding = true;
    button.disabled = true;
    button.textContent = "Adding...";
    setError("");

    if (clickNativeAddToCart(form,button)) {
      return;
    }

    var cartData = new FormData();
    cartData.append("id", state.variantId);
    cartData.append("quantity", getQuantity(form));
    Object.keys(properties).forEach(function (key) {
      cartData.append("properties[" + key + "]", properties[key]);
    });

    try {
      var response = await fetch(shopifyRoute("cart/add.js"), {
        method: "POST",
        body: cartData,
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      });
      var payload = await response.json();
      if (!response.ok) {
        throw new Error(payload.description || payload.message || "Unable to add to cart.");
      }

      window.location.href = shopifyRoute("cart");
    } catch (error) {
      state.isAdding = false;
      button.textContent = "Add to cart";
      updateTotal();
      setError(error.message || "Unable to add to cart.");
    }
  }

  function bindVariantChanges(form) {
    form.addEventListener("change", function () {
      window.setTimeout(function () {
        state.variantId = getVariantId(form);
      }, 0);
    });
  }

  async function init() {
    var form = getProductForm();
    if (!form) return;

    state.productId = currentProductId;
    /*state.product = await getProductFromShopify();
    state.productId = getProductId(state.product);*/
    state.variantId = getVariantId(form);
    state.config = await loadConfig(state.productId);
    if (!state.config) return
    renderCalculator(form);
    bindVariantChanges(form);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
